import React, { forwardRef } from "react";
import { View, ScrollView, useWindowDimensions, Platform, Dimensions } from "react-native";
import { BottomSheet, theme, Text, typography, Modal as ModalComponent } from "ui-components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import { RootState } from "../../../redux/reducers";
import { Stack } from "../../layout/stack";
import { testProps } from "../../../utils/testProps";

const webMaxWidth = 1200;
const tabMaxWidth = 992;
const mobileWebMaxWidth = 768;
const mobileMaxWidth = 576;

interface PaymentDetailsProps {
  height?: number | string;
  children?: any;
  screenWidth?: number;
  labels?: string[];
  values?: string[] | number[];
}

export const PaymentDetails = forwardRef(
  ({ children, height, labels, values }: PaymentDetailsProps, ref: any) => {
    const navigation = useNavigation();
    const { width: screenWidth } = useWindowDimensions();

    const dispatch = useDispatch();
    let CustomTag = screenWidth <= mobileWebMaxWidth ? BottomSheet : ModalComponent;
    const cognitoUser = useSelector((state) => state.auth.cognitoUser);
    const logger = useSelector((state: RootState) => state.logger);
    return Platform.OS == "web" ? null : (
      <CustomTag
        ref={ref}
        height={height || "40%"}
        showCloseIcon={screenWidth <= webMaxWidth ? true : false}
        containerStyle={{
          // width: "auto",
          width:
            screenWidth <= mobileWebMaxWidth
              ? "100%"
              : screenWidth >= mobileWebMaxWidth && screenWidth <= webMaxWidth
              ? 400
              : 500,
        }}>
        <View style={{ maxHeight: Dimensions.get("window").height - 100 }}>
          <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ flexGrow: 1 }}>
            <Stack space="medium">
              <Text
                style={[typography.title1, { color: theme.colors.text3 }]}
                {...testProps("payment-details-popup-heading")}>
                Details
              </Text>

              <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                <DetailsBox label={labels[0]} value={values[0]} />
                <DetailsBox label={labels[1]} value={values[1]} />
              </View>
              <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                <DetailsBox label={labels[2]} value={values[2]} />
                <DetailsBox label={labels[3]} value={values[3]} />
              </View>
              <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                <DetailsBox label={labels[4]} value={values[4]} />
                <DetailsBox label={labels[5]} value={values[5]} />
              </View>
            </Stack>
          </ScrollView>
        </View>
      </CustomTag>
    );
  }
);

interface DetailsBoxProps {
  label?: string;
  value?: string | number;
}
const DetailsBox = (props: DetailsBoxProps) => {
  let { label, value } = props;
  return (
    <View
      style={{
        padding: 8,
        borderColor: theme.colors.stroke,
        borderWidth: 0.5,
        borderRadius: 5,
        flex: 0.48,
      }}
      {...testProps("payment-details-popup-box")}>
      <Text
        style={[typography.body, { color: theme.colors.text2 }]}
        {...testProps("payment-details-popup-label-" + label + "-text")}>
        {label}
      </Text>
      <Text
        style={[typography.title2, { color: theme.colors.secondary }]}
        {...testProps("payment-details-popup-value-" + label)}>
        {value}
      </Text>
    </View>
  );
};
